module.exports = {
  search: '搜索',
  isCustomer: '客户',
  isBookingAgent: '订舱代理',
  isOverseaAgent: '目的港代理',
  isDesignationAgent: '指定货代理	　',
  isLocalAgent: '本地代理',
  isSeaCmp: '船公司　',
  isAirCmp: '航空公司',
  isCustomsBroker: '报关行',
  isTruckCmp: '卡车公司',
  isWarehouse: '仓库',
  isGlobal: '集团公司',
  isShipper: '发货人',
  isConsignee: '收货人',
  isNotify: '通知人',
  isActive: '是否有效',
  isShowHq: '是否显示HQ客户',
  btMerge: '合并',
  btnRemove: '删除',
  btnAdd: '增加',
  btnRefresh: '刷新',
  btnLookUp: '查看',
  totalCount: '总记录数',
  btAudit: '审核',
  btCacelAudit: '取消审核',
  approvedState: '审核状态',
  approvedBy: '审核人',
  dateApproved: '审核日期',
  dateCreated: '创建日期',
  to: '至',
  dateModified: '修改日期',
  parter: '合作伙伴',
  customerType: '客户类型',
  sales: '销售',
  customerLevel: '客户级别',
  whetherReview: '是否审核',
  whetherEffective: '是否有效',
  amount: '条数',
  query: '查询',
  add: '新增',
  delete: '删除',
  view: '查看',
  review: '审核',
  batchPrint: '批量打印',
  B2BRegistrationInvitation: 'B2B注册邀请',
  freightAuthorization: '运价授权',
  combine: '合并',
  batchEditInvoiceHeader: '批量更改开票抬头',
  batchEditSalers: '批量更改销售',
  batchEditServer: '批量更改服务人员',
  templateDownload: '模板下载',
  import: '导入',
  exportAgentList: '导出代理清单',
  downloadImportTemplate: '导入模板下载',
  downloadImportResults: '下载导入结果',
  number: '编号',
  abbreviation: '简称',
  code: '代码',
  chineseName: '中文名称',
  englishName: '英文名称',
  branchCompany: '分公司',
  creator: '创建人',
  creationDate: '创建日期',
  modifier: '修改人',
  modificationDate: '修改日期',
  ecommerceCustomer: '电商客户',
  day30day: '30天(票)',
  day60day: '60天(票)',
  day90day: '90天(票)',
  gt90day: '大于90天(票)',
  all: '全部',
  yes: '是',
  no: '否',
  return: '返回',
  edit: '编辑',
  save: '保存',
  cancel: '取消',
  basicInformation: '基础信息',
  contacts: '联系人',
  customer: '客户',
  creditAccount: '信用账款',
  contractNumber: '合同约号',
  documentation: '文件资料',
  doorInformation: '门点信息',
  specialRequirements: '特殊要求',
  invoicingRequirements: '开票要求',
  destinationPortHandlingAgent: '目的港操作代理',
  destinationNominatedAgent: '目的港指定货代理',
  portLocation: '所在港口',
  spaceCarrier: '舱位承运人',
  spaceAgent: '舱位代理',
  warehouseInformation: '仓库信息',
  EDIConfiguration: 'EDI配置',
  AddressInformation: '地址信息',
  BranchAuthorization: '分公司授权',
  activity: '活跃',
  inactiveReason: '停用原因',
  clearInactiveReasonFirst: '请先清除停用原因',
  crossTenantAuthorize: '跨Tenant委托',
  crossTenantAuthorizeAgreement: '跨Tenant委托协议',
  agree: '同意',
  theOtherPlatformID: '对方平台ID',
  seaCmpAgent: '船代',
  destinationAgent: '目的港代理',
  nominatedAgent: '指定货代理',
  localAgent: '本地代理',
  settlementAgent: '结算代理',
  shippingCompany: '船公司',
  airlineCompany: '航空公司',
  customsBroker: '报关行',
  warehouse: '仓库',
  truckCompany: '卡车公司',
  shipper: '发货人',
  consignee: '收货人',
  notify: '通知人',
  chkMustInputScn: '收发通是否必填',
  others: '其他',
  relatedBusinessType: '相关业务类型',
  oceanExport: '海运出口',
  oceanImport: '海运进口',
  airExport: '空运出口',
  airImport: '空运进口',
  relatedBranch: '关联分公司',
  paymentType: '付款类型',
  whetherCollection: '是否托收',
  usingSettlementAgent: '使用结算代理',
  country: '国家(地区)',
  province: '省',
  city: '市',
  district: '区',
  address: '地址',
  postCode: '邮编',
  telephone: '电话',
  fax: '传真',
  website: '网址',
  rmbAccount: '人民币账号',
  usdAccount: '美元账号',
  taxRate: '税率',
  additionalDescription: '附加说明',
  tel: '电话',
  sapCustomerCode: 'SAP客户编码',
  sapSupplierCode: 'SAP供应商编码',
  isSignContract: '是否签约',
  ContractStatus: '签约状态',
  ClientContractStatus: '客户合同签约状态',
  SupplierContractStatus: '供应商合同签约状态',
  OverseasAgencyContractStatus: '海外代理合同签约状态',
  OtherContractStatus: '其他合同签约状态',
  ContractApproxStatus: '合同约号状态',
  name: '联系人',
  function: '职能',
  isDefault: '是否默认',
  Email: '邮件地址',
  mobile: '手机',
  pushNode: '推送节点',
  pushMode: '推送方式',
  remark: '备注',
  airline: '航线',
  departmentBelonging: '归属部门',
  peers: '同行',
  isPeers: '是否同行',
  introductionDate: 'i-trace启用日期',
  customerSpace1: '揽货类型',
  customerSpace2: '指定货',
  customerSpace3: '自揽货',
  portOfDestination: '目的港',
  theCorrespondingServicePartners: '合作伙伴对应的服务人员',
  theCorrespondingServiceOverseaAgent: '目的港代理对应的海外客服',
  positionType: '岗位类型',
  businessType: '业务类型',
  user: '用户',
  creditControlSettings: '信控设置',
  defaultCreditInfoSettings: '默认信控维护',
  defaultCreditInfoNote: '注：当维护默认信控后，系统中新建合作伙伴时默认信控取当前维护的信控内容！',
  dateType: '日期类型',
  settlementMethod: '结算方式',
  monthlySettlement: '按月结算',
  blacklist: '黑名单',
  accountPeriod: '账期',
  limit: '额度',
  settlementType: '结算类型',
  settlementByBill: '票结',
  settlementNotByBill: '非票结',
  revenueAndExpenditureType: '收支类型',
  collections: '收款',
  payment: '付款',
  depositAmount: '押金金额',
  revenueAndExpenditureDate: '收付日期',
  revenueAndExpenditureMethod: '收付方式',
  cash: '现金',
  depositCurrency: '押金币种',
  day: '天',
  week: '周',
  month: '月',
  space1: '业务日期',
  space2: '发票日期',
  space3: '按周计算',
  space4: '月每月指定日期',
  space5: '半月结',
  space6: '支票',
  space7: '转账',
  space8: '本票',
  space9: '代收代付',
  space10: '银行授信',
  effectiveDate: '生效日期',
  expiryDate: '失效日期',
  fileNumber: '文件编号',
  remarks: '备注',
  documentSize: '附件数量',
  attachment: '附件',
  uploadFile: '上传文件',
  upload: '上传',
  download: '下载',
  fileName: '文件名',
  fileType: '文件类型',
  fileFormat: '文件格式',
  fileSize: '文件大小',
  viewFile: '查看文件',
  whetherUploadContractAttachment: '是否上传合同附件',
  doorName: '门点名称',
  contact: '联系人',
  doorAddress: '门点地址',
  canOverPrice: '是否可高开',
  invoicingMethod: '开票方式',
  invoicingPerBill: '单票开票',
  invoicingPerMonth: '月结开票',
  invoicingNote: '开票备注',
  invoiceHeader: '开票抬头',
  registrationNumber: '纳税人识别号',
  invoiceAddress: '发票地址',
  bankOfInvoiceHeader: '开票抬头银行',
  operation: '操作',
  bankMaintenance: '银行维护',
  confirm: '确定',
  currency: '币种',
  bankName: '银行名称',
  bankAccount: '银行帐号',
  swiftCode: 'SWIFT CODE',
  paymentLine: '联行号',
  forecastReceivingEmail: '预报接收邮箱地址',
  oceanBillOfLadingAddress: '海运提单地址',
  airBillOfLadingAddress: '空运提单地址',
  agentLevel: '代理等级',
  networkManager: '网络负责人',
  billingAddress: '账单地址',
  network: '网络',
  portName: '港口名称',
  carrier: '承运人',
  carrierType: '承运人类型',
  bookingMethod: '订舱方式',
  choose: '-请选择-',
  bookingAgent: '订舱代理',
  ediSenderCode: 'EDI发送方代码',
  ediReceiverCode: 'EDI接收方代码',
  bookingPartyCode: '订舱人代码',
  loadFailed: '加载失败',
  deleteing: '正在删除....',
  deleted: '已删除',
  occurredError: '错误产生',
  deleteConfirmTitle: '删除确认',
  deleteConfirmMessage: '是否确定要删除该数据',
  formatInformation: '格式化信息',
  notFormatInformation: '非格式化信息',
  formatSynchronize: '同步格式化信息至非格式化信息',
  codeAbbreviation: '代码缩写',
  enterpriseCode: '企业代码',
  partnerName: '名称',
  detailAddress: '详细地址',
  phone: '电话号码',
  email: 'EMAIL地址',
  relexNumber: '电传号码',
  cityName: '城市名称',
  provinceCode: '省份代码',
  provinceName: '省份名称',
  postalCode: '邮政编码',
  countryCode: '国家代码',
  aeoEnterpriseCode: 'AEO企业编码',
  specificContactName: '具体联系人名称',
  specificContactPhone: '具体联系人电话号码',
  specificContactAddress: '具体联系人EMAIL地址',
  specificContactRelexNumber: '具体联系人电传号码',
  WarehouseType: '仓库类型',
  WarehouseName: '仓库名称',
  WarehouseAddress: '仓库地址',
  WarehouseMap: '仓库地图',
  PleaseSelect: '请选择',
  Number: '票数',
  GreaterThan: '大于',
  LessThan: '小于',
  EqualTo: '等于',
  WhetherToPushSOPStatus: '是否推送sop状态',
  Push: '推送',
  NoPushing: '不推送',
  portAgent: '口岸代理',
  forwardingAgent: '发运代理',
  loadingPlaceCompany: '装货地公司',
  signBillPlaceCompany: '签单地公司',
  dischargePortCompany: '卸货港公司',
  destinationPortCompany: '目的港公司',
  ParentCompany: '母公司',
  SelectFile: '选择文件',
  DeleteFile: '删除文件',
  Confirm: '确定',
  Cancel: '取消',
  FileName: '文件名',
  FileType: '文件类型',
  FileSize: '文件大小',
  Uploader: '上传人',
  UploadTime: '上传时间',
  UploadProgress: '上传进度',
  DocumentType: '文档类别',
  UnselectedContact: '未选择联系人',
  PartnerNotSaved: '合作伙伴未保存',
  UpdateMaterial: '上传资料',
  DataNotSelected: '数据未选择',
  RailwayExport: '铁路出口',
  RefuseRemark: '拒绝原因',
  Refuser: '拒绝人',
  RefuseDate: '拒绝日期',
  REMARKS: '附加说明',
  InternalRemark: '内装备注',
  supplyChainLines: '供应链线路',
  Middleman: '中间商',
  Factory: '工厂',
  CompanyName: '公司名称',
  Company: '公司',
  contacts_name: '联系人',
  contacts_function: '职能',
  contacts_telephone: '电话',
  contacts_email: '邮件地址',
  contacts_mobile: '手机',
  contacts_remark: '备注',
  credit_creditControlSettings: '信控设置',
  credit_dateType: '日期类型',
  credit_creditControlSettings_date: '信控设置日期类型',
  credit_creditControl_date: '信控日期类型',
  credit_settlementMethod: '结算方式',
  credit_monthlySettlement: '按月结算',
  credit_blacklist: '黑名单',
  credit_accountPeriod: '账期',
  credit_limit: '额度',
  credit_settlementType: '结算类型',
  credit_settlementByBill: '票结',
  credit_settlementNotByBill: '非票结',
  credit_revenueAndExpenditureType: '收支类型',
  credit_collections: '收款',
  credit_payment: '付款',
  credit_depositAmount: '押金金额',
  credit_revenueAndExpenditureDate: '收付日期',
  credit_revenueAndExpenditureMethod: '收付方式',
  credit_cash: '现金',
  credit_depositCurrency: '押金币种',
  credit_additionalDescription: '附加说明',
  credit_day: '天',
  credit_week: '周',
  credit_month: '月',
  credit_space1: '业务日期',
  credit_space2: '发票日期',
  credit_space3: '按周计算',
  credit_space4: '月每月指定日期',
  credit_space5: '半月结',
  credit_space6: '支票',
  credit_space7: '转账',
  credit_space8: '本票',
  credit_space9: '代收代付',
  credit_space10: '银行授信',
  credit_wtCreateCompany: '一键添加平台认证合作伙伴',
  partnerReview: '合作伙伴审核',
  partnerReviewed: '合作伙伴已审核',
  fillRejectReason: '请填写拒绝原因',
  auditRejected: '审核已拒绝',
  changeServicePersonnel: '更改服务人员',
  userName: '用户名称',
  batchChangeSales: '批量更改销售结果',
  positionTypeNotSelected: '岗位类型未选择.',
  multipleSameBusinessPosition: '存在多条相同业务岗位记录.',
  defaultValueNotEmpty: '默认值不能为空!',
  setInitialPassword: '设置初始密码',
  openB2BAccount: '开通B2B账号',
  openB2BSettings: '开通B2B设置',
  batchSelectBookingAgent: '请选择对应的订舱代理！',
  modificationOfBookingAgents: '批量修改订舱代理',
  resetPassword: '重置密码',
  b2bUsers: 'B2B用户',
  selectNotOpenedB2BAccount: '请选择未开通B2B账号的联系人.',
  emailAddressIsIllegal: '的Email地址不合法!',
  selectAnApprovedPartner: '请选择已审核的合作伙伴',
  inputAPassword: '请输入密码!',
  accountOpenedSuccessfully: '账号开通成功!',
  selectAContact: '请选择联系人',
  oneContactPasswordCanResetATime: '每次只能重置一个联系人的密码',
  notOpenedB2BAccount: '此联系人还没有开通B2B账号',
  confirmToReset: '确认要重置',
  yourLoginPassword: '的登录密码吗?',
  openResetPasswordLink: '重置成功，请打开邮箱中的重置密码链接，进行重置。',
  batchModifyServicePersonnel: '批量修改服务人员',
  exportModificationResults: '导出修改结果',
  partnerAbbreviation: '合作伙伴简称',
  chineseNameOfPartner: '合作伙伴中文名称',
  servicePersonal: '服务人员',
  isItSuccessful: '是否成功',
  enterUserInformation: '请输入用户信息',
  selectAUserToModify: '请选择修改用户',
  modifyInvoicingHeader: '修改开票抬头',
  batchModifyInvoicingHeader: '批量修改开票抬头',
  enterBillingHeaderInformation: '请输入开票抬头信息',
  batchChangeSalesperson: '批量更改销售员',
  modifySalesperson: '修改销售员',
  batchModifySalesperson: '批量修改销售员',
  salesman: '销售人员',
  selectRecordToExport: '请选择需要导出的记录！',
  mergedPartners: '被合并的合作伙伴',
  notPermissionEditOverseasAgent: '你没有权限编辑海外代理!',
  notPermissionEditCarrier: '你没有权限编辑承运人!',
  companyIsSettlementAgentFollowingPartners: '此公司目前已经是下列合作伙伴的结算代理',
  confirmDisassociateAndSaveModification: '是否确定解除关联并保存修改内容',
  affiliatedBranch: '所属分公司',
  contractAffiliatedBranch: '合同所属分公司',
  alreadyAPartner: '是否已是合作伙伴',
  selectAPartner: '请选择合作伙伴!',
  applicationSentSuccessfully: '已成功发送申请!',
  addPlatformCertificationPartners: '添加平台认证合作伙伴，与“沃行之家”交互，共建物流生态圈。',
  tariffLevelAuthorization: '运价级别授权',
  fullContainerFreightRate: '整箱运价',
  lclFreightRate: '拼箱运价',
  airFreightRate: '空运运价',
  fbaRate: 'FBA报价',
  mergePartners: '合并合作伙伴',
  updateSupplierData: '更新客商数据',
  maintainInformation: '批量维护信控',
  batchBlacklistSetting: '批量黑名单设置',
  maintainDefaultCreditInfo: '默认信控',
  freightFateLevelIsAuthorized: '运价级别授权给客户组，非个人',
  servicePersonnelSettingNotEnabled: '未启用合作伙伴对应的服务人员设置',
  deletedWithAdministratorPermission: '拥有管理员权限才可删除!',
  partnerNotSelected: '合作伙伴未选择.',
  partnerBeenUsedByBusiness: '合作伙伴已被业务使用.',
  mergedPartnerBeenAssociatedWithCRM: '被合并的合作伙伴已关联CRM',
  mergedPartnerBeenAssociatedWithCRM1: '被合并的合作伙伴已关联CRM，是否{0}，解除后的合作伙伴可前往“客户回收站“菜单进行查看。',
  mergedPartnerBeenAssociatedWithCRM2: '强制解除关联关系',
  removeAssociationWithPartner: '请去【销售-本组客户】/【销售-客户公海】移除与合作伙伴的关联关系。',
  partnersWithCustomerAttributeCanBeSelected: '只能选择属性为客户的合作伙伴',
  partnersWithOverseaAgentAttributeCanBeSelected: '只能选择属性有目的港代理的合作伙伴。',
  authorizationSucceeded: '授权成功',
  groupCompaniesCannotBeMerged: '不能合并集团公司!',
  chooseADifferentPartner: '请选择不同的合作伙伴!',
  noAuthorityToAuditCustomerRolePartners: '您无权审核勾选数据中的客户角色合作伙伴！！！',
  noAuthorityToAuditSupplierRolePartners: '您无权审核勾选数据中的供应商角色合作伙伴！！！',
  vouchersBeenGeneratedContinue: '已生成过凭证,是否继续合并？',
  mergeSuccessful: '合并成功',
  uploadXLSFormatFile: '请上传xls/xlsx格式文件!',
  updateSucceeded: '更新成功!',
  failedUpdateSupplierData: '更新客商数据失败!',
  industrialAndCommercialInformationQuery: '工商信息查询',
  fleetCode: '车队编码',
  platformSupplier: '平台供应商',
  ouJian: '欧坚',
  supplierPrincipal: '供应商负责人',
  supplierDepartment: '供应商所属部门',
  crossTenantEntrustedBookingGeneralProtocol: 'CARGOWARE平台跨Tenant委托订舱通用协议',
  traders: '贸易商',
  shortNameCannotBeEmpty: '简称不能为空',
  oneBusinessTypeForCustomer: '客户的业务类型至少选择一项',
  customerAddressNotEmpty: '客户的地址不能为空.',
  partnerRoleMustBeSelected: '合作伙伴角色必须选择一项',
  customerBusinessTypeMustBeSelected: '客户的业务类型必须选择一项',
  usedByVoucherCannotModified: '已经被凭证使用，不能修改',
  usedByVoucherAreYouSureModified: '此合作伙伴已生成凭证，确定要改吗？',
  duplicatePartnerCodeAlreadyExists: '已存在重复的合作伙伴代码,请检查合作伙伴代码!',
  partnerSameNameAlreadyExists: '已存在同名的合作伙伴,请检查中文名或英文名.',
  online: '网上',
  paper: '纸质',
  carrierNotSelected: '承运人未选择.',
  carrierAlreadyExists: '承运人已存在.',
  bookingMethodNotSelected: '订舱方式未选择.',
  shortMessage: '短信',
  alreadyDefaultContact: '已经有默认联系人，保存会以当前联系人为默认值',
  notSaveTwoDefaultContact: '无法保存两条默认联系人！',
  contactNameAndPhoneNumberCannotBlank: '联系人姓名和电话不能为空！',
  contactNameCannotBlank: '联系人姓名不能为空！',
  emailBlankOrFormatError: '邮箱为空或格式错误！',
  mobileBlankOrFormatError: '手机号为空或格式错误！',
  sameAirlineInvalidMsg: '{0}有相同航线的【{1}】已存在相同的【{2}】，请勿重复添加！',
  mailMode: '邮件接收',
  phoneMode: '短信接收',
  syncContact: '同步数据到合作伙伴联系人中',
  currentJob: '当前业务',
  mobilePhoneNumberValidNumber: '手机号码只能为有效数字',
  emailFormatError: 'Email格式错误',
  emailLengthCannotExceed128Characters: 'Email长度不能超过128个字符',
  phoneNumberLengthCannotExceed32Characters: '手机号码长度不能超过32个字符',
  phoneNumberCannotLongerThan32Characters: '电话号码长度不能超过32个字符',
  expenseFinancialDate: '费用财务日期',
  dailySettlement: '按天结算',
  adjustContractInformationInBasicData: '贵司已开通合同管理菜单，有效期内的合同信控信息，请在基础资料-合同管理中进行调整！',
  masterAgent: '主代理',
  secondaryAgent: '二级代理',
  billAddressCannotEmpty: '账单地址不能为空!',
  nmsCannotEmpty: '网管不能为空!',
  firstPlease: '请先',
  selectImportFile: '选择导入文件：',
  fileSizeCannotExceed20m: '文件大小不可超过20M',
  startImport: '开始导入',
  emailAddress: 'Email地址',
  specificContactEmailAddress: '具体联系人Email地址',
  userCannotEmpty: '用户不能为空!',
  destinationOperationAgentNotMaintained: '目的港操作代理未维护.',
  completeInputItems: '请将输入项补充完整',
  disassociateAndSaveModifications: '是否确定解除关联并保存修改内容?',
  alreadyDefaultBankInformation: '已经有默认银行信息，保存会以当前银行信息为默认值',
  ordinary: '普通',
  supervise: '监管',
  warehousingRequirements: '进仓要求',
  alreadyDefaultWarehouse: '已经有默认仓库，保存会以当前仓库为默认仓库',
  operateInMasterDataContractManagement: '贵司已开通【合同管理】菜单权限，请在基础资料-合同管理中进行操作！',
  contract: '合同',
  effectiveAndExpirationDateCannotBlank: '生效日期和失效日期不能为空',
  fileDeletedSuccessfully: '文件删除成功！',
  viewContactInformation: '查看联系方式',
  lineAlreadyExistsAndCannotAddedRepeatedly: '此线路已存在，不可重复添加',
  vendorCannotEmpty: 'Vendor 不能为空！',
  confirmDeleteSupplyChainLine: '是否确定删除此供应链线路？',
  deleteSupplyChain: '删除供应链',
  emailAddress2: '邮箱地址',
  setDefaultAutoSendMailbox: '设置为默认自动发送邮箱',
  alreadyDefaultInvoicingHeader: '已经有默认开票抬头，保存会以当前开票抬头为默认值',
  branchCannotBlank: '分公司不能为空.',
  cannotRepeat: '不能重复.',
  bookingAgentNotSelected: '订舱代理未选择.',
  bookingAgentAlreadyExists: '订舱代理已存在.',
  defaultMarkupRange: '默认加价幅度',
  rateClass: '运价等级',
  batchSaveSucceeded: '批量保存成功',
  priceAdjustmentRecordUsedAndCannotDeleted: '已使用过调价记录，无法删除。',
  deleteSucceeded: '删除成功!',
  selectAppointmentNumberToEdit: '请选择你要编辑的约号！',
  shipSecretaryAppointmentNumberCannotEmpty: '船司约号不能为空!',
  innerContractNoCannotEmpty: '内部约号不能为空!',
  effectiveDateCannotBlank: '生效日期不能为空!',
  expirationDateCannotBlank: '失效日期不能为空!',
  expirationDateMustGreaterEqualEffectiveDate: '失效日期必须大于等于生效日期!',
  defaultPriceIncreaseRangeCannotBlank: '默认加价幅度不能为空!',
  selectRouteCorrespondingToDestinationPort: '请选择目的港对应的航线!',
  oneRecordWithoutRouteAndDestination: '无航线和目的港的记录只能有一条!',
  sameRoute: '相同航线',
  oneRecordCanGeneratedPleaseModify: '只允许生成一条记录，请修改!',
  sameRouteAndDestination: '相同航线和目的港',
  samePol: '相同起运港',
  associatedRoute: '关联航线',
  isParentCompany: '是否母公司',
  isFba: '是否FBA',
  subsidiaryInformation: '子公司信息',
  deleteSubsidiaryTips: '请勾选想要删除的子公司！',
  deleteSubsidiaryConfirm: '移除后将解除母公司与子公司的关系，是否继续？',
  changeParentCompany: '已经有关联的子公司，请先解除与子公司关系后再操作！',
  officeChangeForSubsidiaryCompany: '已经有关联的子公司，修改后子公司编辑母公司时，可能选不到该合作伙伴，是否继续？',
  quota: '额度',
  monthlySpecifiedDate: '每月指定日期',
  weeklySettlement: '按周结算',
  semilunarKnot: '半月结',
  settlementDay: '按天结算',
  statementDate: '账单日期',
  customerSupplierType: '客商类型',
  CustomerMailbox: '客户邮箱',
  WhetherToSendMailAutomatically: '是否自动发送邮件',
  DefaultMailSendingObject: '默认邮件发送对象',
  DefaultMailSendingObjectTip: '如选择邮件推送对象邮箱地址为空，则发送给发票创建人',
  BulkUpdateSurcharge: '批量更新附加费',
  autoEmailSettings: '自动发送邮件设置',
  taxControlPlatformSending: '税控平台发送',
  systemAutomaticSending: '系统自动发送',
  systemAutomaticSendingObject: '系统自动发送对象',
  taxControlPlatformSendingObject: '税控平台发送对象',
  partnerInvoiceReminder: '税控平台及本系统可分别发送邮件到指定邮箱。若启用自动发送，但选择的邮件推送对象邮箱地址为空，则发送给发票创建人。',
  interestFreeCompany: '免息公司',
  uniformRenewalSurcharge: '统一更新附加费',
  lookSurcharge: '查看附加费',
  batchReplaceAfterSave: '提示：保存后将批量替换掉之前维护的附加费，对本次约号价格下所有航线生效。',
  validityPeriodRepeatedAndCannotCopy: '有效期重复，不可复制',
  sameRoutePodPol: '相同航线、起运港、目的港',
  sameRoutePol: '相同航线和起运港',
  agreementContent: `甲  方：跨Tenant委托订舱委托方（以下简称甲方）
  乙  方：跨Tenant委托订舱接收方（以下简称乙方）

  甲、乙双方遵循“提高效率、减少环节、促进发展、明确责任、规范行为”的宗旨，根据国家和上海市有关法律和法规的规定，就乙方通过CARGOWARE平台使用电子订舱的形式向甲方订舱，按照“平等互利、协商一致”的原则，达成如下协议：

  第一章  总则
  1.本协议为甲方通过CARGOWARE平台以跨Tenant委托的电子订舱方式就所涉海运出口业务与乙方所订立的正式通用协议；甲乙双方在CARGOWARE平台跨Tenant委托功能处勾选同意本协议项时起，CARGOWARE平台即视为该平台用户已经认同本协议的责任和义务之约定；
  2.甲方应为依法设立持有有效营业执照并在营业执照所列经营范围内合法经营国际货物运输代理业务的具有独立法人资格的公司或企业；
  3.乙方应为依法设立持有有效营业执照并在营业执照所列经营范围内合法经营国际货物运输代理业务的具有独立法人资格的公司或企业；
  4.甲乙双方通过CARGOWARE平台注册审核后合法获得平台企业用户ID和Key（电子数据签名）。双方以此电子数据签名通过数据CARGOWARE平台进行的任何动作，均视为双方做出的真实意思表示，并对此确认并愿意自行承担因此而产生的一切责任和风险；
  5.甲方同意以平台跨Tenant委托的电子订舱替代纸面的订舱托运单和以Tenant ID和Key形式替代订舱章的形式向乙方申请订舱；
  6.乙方以跨Tenant委托电子回执替代纸面的订舱配舱回单并以Tenant ID和Key形式确认订舱，接受甲方委托；乙方将按双方相关业务协议规定的各项条款，代甲方向承运人或承运人的代理进行货物出口的配舱、装船；进仓、装箱、装船等一系列货运代理业务；
  7.甲乙双方采取跨Tenant委托的电子订舱流程机制和实现方式由数据云平台事先制定，甲乙双方均在此功能项处填写对方的Tenant ID；
  8.甲乙双方均有责任防止非法侵入或非法传输，确保各自发送和接收的操作人员具有合法授权，切实保护业务记录和数据不受非法侵入、篡改或损毁的义务；
  9.乙方在收到甲方的跨Tenant委托电子订舱申请报文后，应及时通过平台发出回执。甲方应时刻关注自己电子订舱委托申请的状态，如没有收到对方处理信息，甲方有义务尽快与乙方联系并查找原因；
  10.甲乙双方未能在约定的合理时间内收到确认时，应采取相应措施，否则双方有权假定最初传送已经被收到，CARGOWARE平台不对双方受理的及时性和有效性承担任何责任；
  11.甲乙双方符合平台操作规范要求的跨Tenant委托电子订舱数据和回执信息，具有与书面单证同等的法律效力；甲方对乙方所托运的货物享有运费追索权。
  第二章 费用与结算
  甲乙双方通过跨Tenant委托电子订舱所涉及的业务委托服务，按照双方签订的货运代理协议书及相关的费用结算协议的具体条款执行。
  第三章 双方的权利义务
  1.若因甲方原因对CARGOWARE平台提供的电子数据签名保管不善或授权操作不严谨导致他人使用或非法使用和进行数据操作，由甲方承担相应后果；
  2.甲方向乙方发送的数据电文或在甲方电子系统中在线输入的内容应包括但不限于准确的预配船期或航空器的航班、承运人名称、运编号、提单号、协议号、目的港、卸货港、货物明细（品名、件数、毛重、体积、货物的属性描述、特殊货物的尺寸等）、运费条款、预配箱型箱量、发货人、收货人、通知人、唛头和其他需要特别注明的信息，并依据双方约定的内容形式发送；
  3.对于甲方委托订舱出运的特殊货物，如危险品、冷藏货、超尺寸货物、需箱检货或需要特殊箱才能承载的货物，以及其他特殊货物需提供纸质书面确认函件甲方才能接受其订舱，如超尺寸货物的图纸资料和冷藏箱预冷证明等。对危险品货物还需提供纸面的危险货物申报单和危险货物装箱证明书及其他承运人要求的单证等。对某些需要先付费再订舱的货物，应及时向乙方付费，然后才能接受订舱；
  4.甲方对所托运货物的真实信息应在电子订舱报文中如实申报，如甲方虚假申报损害了乙方或第三人的利益，甲方需承担相应的损害赔偿责任；
  5.甲方如需对订舱委托信息进行更改，应在货物装入集装箱或杂货进栈（库）的当天通知乙方；甲方应以书面或双方约定的其他形式向乙方申请更改；
  6.甲方对通过电子订舱委托乙方承运的货物有按照约定时间支付运费、附加费及其他费用的义务；
  7.甲方如已订托运单需要退关，应及时通过书面或双方约定的其他形式，否则乙方全部承担由此产生的任何责任与费用。
  8.乙方收到甲方发送的跨Tenant委托电子订舱应在合理的时间内及时以电子数据的形式确认接受或拒绝乙方的订舱委托；
  9.双方由于自身网络、公共网络或CARGOWARE平台出现异常故障，在此期间双方应使用传统的纸面订舱方式开展订舱业务和进行信息传递。
  第四章 电子订舱的确认
  1.乙方在收到甲方的电子订舱数据报文后需在合理时间内及时处理，应按平台要求发送确认接受委托或拒绝的回执，拒绝应说明拒绝理由；
  2.甲方只有在乙方返回确认接受委托的电子订舱回执报文后，才能视为乙方接受了甲方的订舱委托；
  3.甲方如在乙方未确认之前进行了一系列只有在乙方接受甲方的订舱后才能进行的活动，此行为视为侵权，由此产生一切法律责任和风险由甲方承担；
  4.乙方应将按照确认的订舱内容及要求，代表承运人接受甲方的订舱配载委托并办理相关出口运输业务，乙方在本协议项下的任何行为均不能被视为对确认托运单能够得到成功的订舱配载的承诺或保证。
  第五章 协议的履行
  1.甲乙双方应严格履行本协议及条款规定的有关内容。
  2.任何协议当事人不得将本协议下的利益转让给与其他无关的个人或组织。
  3.任何协议当事人在履行本协议规定的义务时，因不可抗力无法履行或无法按时履行与协议有关的事项，应及时通知对方，并尽力采用其他方式。在此期间数据报文发生延迟、脱漏或错误的协议当事人对以上时间造成的不良后果不负责任。
  4.协议的一方若发现违背安全、非法使用或非法行为，应立即通知对方及其他有关方，并进行调查，将调查的结果报告给对方及其他有关各方。在此期间，电子数据应暂时停止直至安全情况恢复到正常情况为止。
  5.甲乙双方签订《货运代理协议书》的，本协议作为该协议的附件，本协议未尽部分按照《货运代理协议书》的相关条款执行。
  第六章 协议的变更和终止
  1.本协议任何一方不得擅自变更和解除协议。如确有特殊原因不能继续履行或需变更时，须经另一方当事人同意，并在协议规定的时间内办理变更或终止协议手续。如在协议规定的期限外提出，必须负担对方已造成的实际损失。
  2.双方达成协议终止本协议的，双方应在CARGOWARE平台跨Tenant委托功能项去除同意项相关并清除相关配置信息。
  第七章 违约责任
  当事人违反协议的约定，应按照此行为给对方所造成的实际损失进行相应的赔偿。
  第八章 其他
  因本协议产生的任何纠纷，双方应在互惠互利的原则下先行协商解决，协商不成的，则向双方注册经营所在地当地的海事法院起诉。`,
  SuccessSyncCloudAndStarrySky: '同步云星空成功',
  FailSyncCloudAndStarrySky: '同步云星空失败，{0}',
  HMSyncYongYouSuccess: '客户数据同步用友成功 。msg "{0}"',
  HMSyncYongYouFail: '客户数据同步用友失败，{0}',
  HMSyncYongYouSuccess2: '供应商数据同步用友成功 。msg "{0}"',
  HMSyncYongYouFail2: '供应商数据同步用友失败，{0}',
  bankEnglishName: '银行名称（英文）',
  bankAddress: '银行地址',
  bankEnglishAddress: '银行地址（英文）',
  EidtBranchNotSameTip: '请将右上角分公司切换到此合作伙伴的所属公司一致时进行编辑操作。',
  BranchNoPartnerPermission: '当前分公司没有权限编辑合作伙伴！',
  DeleteBranchNotSameTip: '请将右上角分公司切换到此合作伙伴的所属公司一致时进行删除操作。',
  operateBranchNotSameTip: '暂无操作权限，请将右上角分公司切换到此合作伙伴对应所属公司一致后再进行操作。',
  BranchNoDeletePartnerPermission: '当前分公司没有权限删除合作伙伴！',
  MergeBranchNotSameTip: '请将右上角分公司切换到此合作伙伴的所属公司一致时进行合并操作。',
  BranchNoMergePartnerPermission: '当前分公司没有权限合并合作伙伴！',
  UnifiedSign: '是否统签',
  IfRisk: '风险客商',
  customerCode: '客户编码',
  supplierCode: '供应商编码',
  customerCodeNotSupportChinese: '客户编码不能输入中文',
  supplierCodeNotSupportChinese: '供应商编码不能输入中文',
  customersAndSuppliersMustChooseOne: '客户和供应商必须选择一个',
  CustomerCodeNotEmpty: '客户编码不允许为空',
  SupplierCodeNotEmpty: '供应商编码不允许为空',
  CustomerCodeCheck: '新一代客户编码格式不正确，请输入【13位数字】',
  SupplierCodeCheck: '新一代供应商编码格式不正确，请输入【ABCD任一字母+7 位数字】',
  CcGroup: '抄送群组',
  CcAddress: '抄送地址',
  ccAgentOverseaOp: '抄送代理对应海外客服',
  UseEmailGroup: '使用邮件群组',
  PartnersApprovedTips: '当前勾选的数据包含已审核不可编辑项，请取消勾选后继续操作',
  isInternalCorrespondent: '是否内部往来公司',
  internalCorrespondent: '内部往来公司',
  batchAddServer: '批量新增服务人员',
  batchAddServerNoSelected: '请选择要新增服务人员的合作伙伴',
  batchAddServerConfigError: '您选择的合作伙伴不支持维护服务人员',
  addServicePersonnel: '新增服务人员',
  BookingAgentLevel: '订舱代理级别',
  bookingAgentLevelNotSelected: '订舱代理级别未选择',
  Underestimation: '计欠',
  IfAdvancePayment: '预付款',
  CreditRemarks: '信用账款附加说明',
  DefaultSettlementForInsurance: '保险默认结算对象',
  DriverInformation: '司机信息',
  DriverName: '司机名',
  DriverPhoneNumber: '司机手机号',
  PlateNumber: '车牌号',
  IdentityCard: '身份证号',
  DriverNameRequired: '司机名必填',
  CreditUnit: '额度单位',
  creditDateUnit: '账期单位',
  b2bDisplay: 'B2B是否显示',
  // 合同限制相关
  enableContractLimit: '启用合同限制',
  disableContractLimit: '禁用合同限制',
  editReleaseDays: '编辑放号天数',
  availableReleaseDays: '可放号天数',
  releaseDeadlineDate: '可放号截止日期',
  ticketSettlementCannotEnable: '当前客户信用账期为票结，不可启用',
  editReleaseDaysConfirm: '当前为第{0}次更新放号天数信息，共累计增加可放号天数{1}天（不含本次更改），是否将客户改为票结客户？',
  editReleaseDaysInfoOnly: '当前为第{0}次更新放号天数信息，共累计增加可放号天数{1}天（不含本次更改）'
}
